// Widget Scripts
import headerButtons from './js/widgets/0-headerButtons.js';

import mainFeatureSlideshow from './js/widgets/1-mainFeatureSlideshow.js';

import * as seoSignup from './js/widgets/seo-signup/index.js';

import manualEventsFeed from './js/widgets/3-eventFeedFeature.js';

import exploreCards from './js/widgets/4-exploreCards.js';
import scrollerSponsors from './js/widgets/5-scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  headerButtons();

  if (globalThis.location.pathname === '/') {
    mainFeatureSlideshow();
    seoSignup.seoWidget();
    seoSignup.staticSignup();
    manualEventsFeed();
    exploreCards();
    scrollerSponsors();
  }
});
